/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { FormikConsumer } from 'formik'
import _ from 'lodash'
import { Txt, Collapse } from '.'

export const FormErrorMessage: React.SFC<{ name: string; ignoreTouched?: boolean }> = ({
  name,
  ignoreTouched,
  ...props
}) => (
  <FormikConsumer>
    {(form: any) => {
      const error = _.get(form.errors, name)
      const touched = _.get(form.touched, name)
      const isOpen = Boolean(error && (ignoreTouched || touched))
      return (
        <Collapse isOpened={isOpen}>
          <Txt {...props} sx={{ color: 'error', fontSize: [0, 0, 1] }}>
            {error}
          </Txt>
        </Collapse>
      )
    }}
  </FormikConsumer>
)

export const GeneralFormErrorMessage: React.SFC<{}> = (props) => (
  <FormErrorMessage name="generalError" ignoreTouched {...props} />
)
